import { TextValue } from '../_general';

export enum AimCreationMethodEnum {
    NONE = 0,
    CROSSING = 1,
    SIF = 2,
}

export const aimCreationMethodText: { [key in AimCreationMethodEnum]: string } = {
    [AimCreationMethodEnum.NONE]: '',
    [AimCreationMethodEnum.CROSSING]: 'Crossing',
    [AimCreationMethodEnum.SIF]: 'SIF',
};

export const aimCreationMethodOptions: TextValue[] = [
    { text: aimCreationMethodText[AimCreationMethodEnum.NONE], value: AimCreationMethodEnum.NONE },
    { text: aimCreationMethodText[AimCreationMethodEnum.CROSSING], value: AimCreationMethodEnum.CROSSING },
    { text: aimCreationMethodText[AimCreationMethodEnum.SIF], value: AimCreationMethodEnum.SIF },
];
